<div class="state-message" *ngIf="isLoading" role="status">
  <i class="bi bi-hourglass-split" style="font-size: 32px; opacity: 0.35;" aria-hidden="true"></i>
  <span>Caricamento dei test Longevity in corso...</span>
</div>

<div class="warning-banner" role="alert" *ngIf="!isLoading && loadFailed">
  <i class="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
  <p>
    Non è stato possibile caricare i test Longevity di questa richiesta.
    <button type="button" class="link-btn" (click)="retry()">Riprova</button>
  </p>
</div>

<div class="state-message" *ngIf="!isLoading && !loadFailed && assessments.length === 0">
  <i class="bi bi-clipboard-heart" style="font-size: 40px; opacity: 0.2;" aria-hidden="true"></i>
  <p>Per questa richiesta non è ancora stato compilato nessun test.</p>
</div>

<div class="table-wrapper" *ngIf="!isLoading && !loadFailed && assessments.length > 0">
  <table>
    <caption class="sr-only">Test Longevity compilati per questa richiesta</caption>
    <thead>
      <tr>
        <th scope="col">Data</th>
        <th scope="col">Punteggio</th>
        <th scope="col">Aree</th>
        <th scope="col">Caso</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr class="table-row" *ngFor="let a of assessments">
        <td class="nowrap">{{ a.savedAt | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td class="total-cell">{{ formatScore(a.total) }}</td>
        <td class="nowrap">
          <span class="grade-chip" [ngClass]="gradeClass(g.grade)" *ngFor="let g of rowGrades(a)"
            [title]="areaLabel(g.area) + ': ' + gradeLabel(g.grade)">{{ g.grade }}</span>
        </td>
        <td class="nowrap">{{ caseStatusLabel(a.status) }}</td>
        <td class="actions-cell nowrap">
          <button type="button" class="btn-copy" (click)="openDetail(a)">Vedi risposte</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-longevity-assessment-modal *ngIf="selectedAssessment" [assessment]="selectedAssessment"
  (closed)="closeModal()"></app-longevity-assessment-modal>
